import React from 'react';
import styled from 'styled-components';
import { Lock } from 'lucide-react';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import { panelAccent } from 'theme/panelAccent';

/**
 * Números de um bloco que o convite não libera, em ••••: mantém o desenho da
 * tela e avisa que os valores existem mas estão restritos.
 *
 * @param {{ labels: string[] }} props o nome de cada número escondido
 */
export default function MaskedStats({ labels }) {
    return (
        <Wrap>
            <Grid>
                {labels.map((label) => (
                    <Stat key={label}>
                        <Label>{label}</Label>
                        <Value aria-label='valor oculto'>••••</Value>
                    </Stat>
                ))}
            </Grid>

            <Hint role='status'>
                <Lock size={12} color={panelAccent(colors.secondaryPurple)} aria-hidden='true' />
                Valores ocultos: o organizador não liberou a visão de vendas para você.
            </Hint>
        </Wrap>
    );
}

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;

    @media screen and (min-width: ${breakpoints.md}) {
        grid-template-columns: repeat(4, 1fr);
    }
`;

const Stat = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px;
    border-radius: 10px;
    background: ${colors.neutral};
    border: 1px solid ${colors.neutralDark};
`;

const Label = styled.span`
    font-size: ${fonts.sizes.small};
    color: ${colors.night};
`;

const Value = styled.span`
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: ${colors.nightLight};
    user-select: none;
`;

const Hint = styled.p`
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    font-size: ${fonts.sizes.small};
    color: ${colors.night};
`;
